import { render } from "./home.vue?vue&type=template&id=6dfb8168"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=6dfb8168&lang=css"
script.render = render

export default script